import {
    ADD_SELECTED_LAYER_TO_PRINT,
    REMOVE_SELECTED_LAYER_FROM_PRINT,
    SET_SELECTED_BASE_LAYER_PRINT
} from './Types';
import {IPrintPanelReducerState, IPrintPanelAction} from "./printPanelTypes";


const defaultState = {
    selectedLayers: [],
    selectedBaseLayer: ''
};

const reducer = (state:IPrintPanelReducerState = defaultState, action:IPrintPanelAction) => {
    switch (action.type) {
        case ADD_SELECTED_LAYER_TO_PRINT:
            return {
                ...state,
                selectedLayers: [...state.selectedLayers, action.systemName]
            };
        case REMOVE_SELECTED_LAYER_FROM_PRINT:
            return {
                ...state,
                selectedLayers: [...state.selectedLayers.filter(systemName => systemName !== action.systemName)]
            };
        case SET_SELECTED_BASE_LAYER_PRINT:
            return {
                ...state,
                selectedBaseLayer: action.systemName
            };
        default:
            return state;
    }
};

export default reducer;